var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBusiness(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 92.14 92.13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#80D4FF;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Business") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M90.71,92.13H1.43a1.43,1.43,0,1,1,0-2.85H90.71a1.43,1.43,0,1,1,0,2.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M63.48,92.13a1.43,1.43,0,0,1-1.42-1.42V2.85H10.46V90.71a1.43,1.43,0,0,1-2.86,0V1.43A1.43,1.43,0,0,1,9,0H63.48a1.43,1.43,0,0,1,1.43,1.43V90.71A1.43,1.43,0,0,1,63.48,92.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M83.11,89.56a1.43,1.43,0,0,1-1.43-1.43V17.75h-17a1.43,1.43,0,0,1,0-2.85H83.11a1.43,1.43,0,0,1,1.42,1.42V88.13A1.43,1.43,0,0,1,83.11,89.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.28,91a1.43,1.43,0,0,1-1.43-1.43V82.9H32.66v6.69a1.43,1.43,0,1,1-2.85,0V81.48a1.43,1.43,0,0,1,1.43-1.43h10a1.43,1.43,0,0,1,1.42,1.43v8.11A1.43,1.43,0,0,1,41.28,91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M55.34,12.42H17.18a1.43,1.43,0,1,1,0-2.85H55.34a1.43,1.43,0,0,1,0,2.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M73,33.57a1.43,1.43,0,0,1-1.43-1.42V27.53a1.43,1.43,0,1,1,2.85,0v4.62A1.43,1.43,0,0,1,73,33.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M73,49.14a1.43,1.43,0,0,1-1.43-1.43V43.09a1.43,1.43,0,0,1,2.85,0v4.62A1.43,1.43,0,0,1,73,49.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M73,64.7a1.43,1.43,0,0,1-1.43-1.42V58.66a1.43,1.43,0,1,1,2.85,0v4.62A1.43,1.43,0,0,1,73,64.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M73,80.27a1.43,1.43,0,0,1-1.43-1.43V74.22a1.43,1.43,0,0,1,2.85,0v4.62A1.43,1.43,0,0,1,73,80.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M55.34,21.46H17.18a1.43,1.43,0,0,1,0-2.86H55.34a1.43,1.43,0,0,1,0,2.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M55.34,30.49H17.18a1.43,1.43,0,0,1,0-2.86H55.34a1.43,1.43,0,0,1,0,2.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M55.34,39.52H17.18a1.43,1.43,0,1,1,0-2.85H55.34a1.43,1.43,0,0,1,0,2.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M55.34,48.55H17.18a1.43,1.43,0,1,1,0-2.85H55.34a1.43,1.43,0,0,1,0,2.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M55.34,57.58H17.18a1.43,1.43,0,1,1,0-2.85H55.34a1.43,1.43,0,0,1,0,2.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M55.34,66.61H17.18a1.43,1.43,0,1,1,0-2.85H55.34a1.43,1.43,0,0,1,0,2.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M55.34,75.65H17.18a1.43,1.43,0,1,1,0-2.86H55.34a1.43,1.43,0,0,1,0,2.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24,84.81h-7a1.43,1.43,0,0,1,0-2.86h7a1.43,1.43,0,0,1,0,2.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M55.34,84.81H48.29a1.43,1.43,0,1,1,0-2.86h7.05a1.43,1.43,0,0,1,0,2.86Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusiness);
export default __webpack_public_path__ + "static/media/Business.ecf7eb4f68eb0bdb3b9e1e9c90146b06.svg";
export { ForwardRef as ReactComponent };